import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`當我們在進行設計和建構軟體系統的時候,總是喪失了許多相關知識-猶如傳話遊戲,這些令人感到困惑的溝通都是因為沒有共同語言,而沒有視覺化的輔助也會讓討論變得複雜,同樣的,沒有善用人類的潛能和天賦也都是可能的因素。失去相關知識會影響到開發中軟體產品其持續性、質量和價值。Kenny 將一些 IT 的方法論,諸如:領域驅動設計,持續交付,視覺化工具,Cynefin 框架,深度民主(Deep Democracy)整合起來。Kenny Baas-Schwegler 藉由社會技術的思維為組織,團隊和人員賦權並共同促進設計和建構可持續發展的高品質軟體產品。`}</p>
    <p>{`Kenny 的其中一項原則就是共享知識。他藉著在他的網站(baasie.com)中撰寫部落格,並且幫忙策畫 Leanpub 書籍的視覺化協作工具來達成知識的共享。除了寫作,他還擔任虛擬領域驅動設計以及 Nederland 領域驅動設計的組織者,活躍於領域驅動社群,並且作為公開的講者在 Meetup 和研討會,以及一些工作坊上進行分享`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      